import React, { useState, useContext, createContext } from "react";
import i18n from "i18next";

const LangContext = createContext();

export function LangProvider({ children }) {
  const lang = useProvideLang();

  return <LangContext.Provider value={lang}>{children}</LangContext.Provider>;
}

export const useLang = () => {
  return useContext(LangContext);
};

function useProvideLang() {
  const getLanguage = () => {
    const userLang = localStorage.getItem("userLang") || "de";
    if (userLang !== i18n.language) {
      // Synchronize with i18next library, only if language really changes.
      // Otherwise the parent component tree may be re-rendered unnecessarily.
      i18n.changeLanguage(userLang);
    }

    return userLang;
  };

  const [currentLanguage, setCurrentLanguage] = useState(getLanguage());

  const handleLanguageChanged = (language) => {
    if (language === "de" || language === "en") {
      setCurrentLanguage(language);
      localStorage.setItem("userLang", language);
      // Synchronize with i18next library
      i18n.changeLanguage(language);
    }
  };

  const [isLanguageDisabled, setLanguageDisabled] = useState(false);

  return {
    currentLanguage,
    setCurrentLanguage: handleLanguageChanged,
    isLanguageDisabled: isLanguageDisabled,
    setLanguageDisabled: setLanguageDisabled
  };
}
